import { PreVettingStep5Screen } from "@/features/vendor/pre-vetting";

export default PreVettingStep5Screen;
